import { ChangeDetectionStrategy, Component, effect, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { CardModule } from 'primeng/card';
import { DividerModule } from 'primeng/divider';
import { SkeletonModule } from 'primeng/skeleton';

import { NewsStore } from './stores/news.store';
import { AppTableLoadingOverlayComponent } from "src/app/shared/components/loading-overlay/table-loading-overlay.component";
import { AppLoadingOverlayComponent } from "src/app/shared/components/loading-overlay/loading-overlay.component";



@Component({
  selector: 'app-news',
  standalone: true,
  imports: [CommonModule, RouterModule, CardModule, DividerModule, SkeletonModule, AppTableLoadingOverlayComponent],
  templateUrl: './news.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewsComponent {
  readonly store = inject(NewsStore);

  constructor() {
    effect(() => this.store.load());
  }

  widgetHeader() {
    return 'NEWS';
  }
}
